(ns app.front.view.group.admin.form-field-selection
  "Subs and events to keep track of the available forms and their fields for admin pages"
  (:require [re-frame.core-instrumented :as rf]))

(rf/reg-sub
  ::raw-form-fields
  (fn [db _]
    (-> db ::raw-form-fields)))

(rf/reg-sub ::forms
  :<- [::raw-form-fields]
  (fn [raw-form-fields _]
    (-> raw-form-fields keys sort)))

(defn get-fields-for-form [raw-form-fields form]
  (->> (get raw-form-fields form [])
       distinct
       (map-indexed #(assoc %2 :index (str %1)))))

(defn form-field-text [form-field]
  (or (:label form-field)
      (str (:field form-field))))

(rf/reg-sub
  ::form-fields
  :<- [::raw-form-fields]
  (fn [raw-form-fields [_ form]]
    (->> form
         (get-fields-for-form raw-form-fields)
         (sort-by form-field-text))))

(rf/reg-sub
  ::all-forms-with-fields
  :<- [::forms]
  :<- [::raw-form-fields]
  (fn [[forms raw-form-fields]]
    (->> forms
         (map #(get-fields-for-form raw-form-fields %)))))

(rf/reg-event-db
  ::fetch-form-fields-success
  (fn [db [_ _ raw-form-fields]]
    (assoc db ::raw-form-fields raw-form-fields)))

(rf/reg-event-fx
  ::fetch-form-fields
  (fn [_ [_ authority-group-id]]
    {:comm/command {:command    :group/form-schemas
                    :method     :get
                    :data       {:authority-group-id authority-group-id}
                    :on-success [::fetch-form-fields-success]}}))
